import React from 'react';
import { Table, TableHeaderColumn, TableRowColumn, TableHeader, TableRow, TableBody } from 'material-ui';


export default () => {
  const border = '1px solid #e0e0e0';
  return (
    <Table style={{ border: '1px solid #e0e0e0' }}>
      <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
        <TableRow style={{ height: '32px' }}>
          <TableHeaderColumn style={{ height: '32px' }} colSpan="1"/>
          <TableHeaderColumn style={{ padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }} colSpan="4">Location Name</TableHeaderColumn>
          <TableHeaderColumn style={{ padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }} colSpan="4">Room Type</TableHeaderColumn>
          <TableHeaderColumn style={{ padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }} colSpan="4">Allotment Start</TableHeaderColumn>
          <TableHeaderColumn style={{ padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }} colSpan="4">Allotment End</TableHeaderColumn>
          <TableHeaderColumn style={{ padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }} colSpan="6">Total # of Rooms on Allotment</TableHeaderColumn>
        </TableRow>
      </TableHeader>
      <TableBody selectable={false} displayRowCheckbox={false}>
        <TableRow style={{ height: '24px' }}>
          <TableRowColumn style={{ height: '24px', textAlign: 'center', padding: 0 }} colSpan="1">1</TableRowColumn>
          <TableRowColumn style={{ padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }} colSpan="4"/>
          <TableRowColumn style={{ padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }} colSpan="4"/>
          <TableRowColumn style={{ padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }} colSpan="4"/>
          <TableRowColumn style={{ padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }} colSpan="4"/>
          <TableRowColumn style={{ padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }} colSpan="6"/>
        </TableRow>
        <TableRow style={{ height: '24px' }}>
          <TableRowColumn style={{ height: '24px', textAlign: 'center', padding: 0 }}>2</TableRowColumn>
          <TableRowColumn style={{ padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }} colSpan="4"/>
          <TableRowColumn style={{ padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }} colSpan="4"/>
          <TableRowColumn style={{ padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }} colSpan="4"/>
          <TableRowColumn style={{ padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }} colSpan="4"/>
          <TableRowColumn style={{ padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }} colSpan="6"/>
        </TableRow>
      </TableBody>
    </Table>
  );
};



// WEBPACK FOOTER //
// ./src/app/components/contracting-reports/sampleTables/summaryAllotment.jsx